module.exports = __webpack_public_path__ + "static/media/my-family-add-16-above.05134288.png";